import DataTable from "../../../components/DataTable";
import { useState, useEffect } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchModulesList } from "../data/moduleService";
import { Button } from "reactstrap";
import { useTheme } from "../../../hooks/useTheme";
import { fetchSuppliers } from "../../suppliers/data/supplierService";
import { useLockState } from "../../../components/userLocks/LockCheck";

const ModulesTableQuote = ({onAddModuleToBasketClicked}) => {
    const theme = useTheme();
    const lockState = useLockState();

    // item state
    const [modules, setModules] = useState([]);

    // ------------------
    // Database Logic
    // ------------------

    const queryClient = useQueryClient();

    // Fetch Suppliers using useQuery
    const {
        data: suppliersData,
        isLoading: isLoadingSuppliers,
        error: suppliersError,
    } = useQuery({
        queryKey: ["Suppliers"],
        queryFn: fetchSuppliers,
        staleTime: 60000
    });

    const getEnabledProductModules = async () => {
        var modules = await fetchModulesList();
        modules = modules.filter(x => x.isSystemModule === false && !x.disabled);

        console.log(modules);
        return modules;
    }

    // Fetch users using useQuery
    const {
        data: modulesData,
        isLoading: isLoadingModules,
        error: modulesError,
    } = useQuery({
        queryKey: ["enabledProductModules"],
        queryFn: getEnabledProductModules,
        staleTime: 60000,
    });

    // When usersData is fetched, update our local state.
    useEffect(() => {
        if (modulesData) {
            console.log('--Modules Data--', modulesData)
            setModules(modulesData);
        }
    }, [modulesData, modules]);

    const columns = [
        {
            key: "iconSortData",
            label: "",
            isSortDisabled: true,
            render: (value, row) => (
                <img src={row.iconData} alt="module" style={{ height: "50px" }} />
            )
        },
        {
            key: "moduleName",
            label: "Name",
        },
        {
            key: "description",
            label: "Description",
        },
        {
            key: "id",
            label: "",
            className: "text-end",
            render: (value) => (
                <Button className={lockState?.isLocked ? "locked" : ""}
                    onClick={
                        (e) => {
                            e.stopPropagation();
                            onAddModuleToBasketClicked?.(value)
                        }
                    }
                >
                    <i className="bi bi-cart-plus"></i>
                </Button>
            )
        }
    ];

    return (
        <>
            <DataTable
                columns={columns}
                data={modules}
                searchableFields={["moduleName", "description"]}
                error={modulesError}
                isLoading={isLoadingModules}
                sortByColumn="moduleName"
                sortDirection="ascending"
            />
        </>
    );
}
export default ModulesTableQuote;